import React, { useState } from 'react';
import { Button, Modal, Spin, notification } from 'antd';
import CustomInput from 'Components/Form/CustomInput/CustomInput';
import { useAppDispatch } from 'Redux/store';
import { getOrder } from 'Redux/Order/reducer';
import { useSelector } from 'react-redux';
import { selectBidLoading } from 'Redux/Bid/slice';
import { selectCurrentOrder } from 'Redux/Order/slice';
import { assignBid } from 'Redux/Bid/reducer';
import { Controller, useForm } from 'react-hook-form';
import styles from './AssigningBidModal.module.scss';

export type AssigningBidModalParams = {
  visible: boolean;
  onCancel: () => void;
  brokerPrice?: number;
  driverPrice?: number;
};

export const AssigningBidModal: React.FC<AssigningBidModalParams> = ({
  visible,
  onCancel,
  brokerPrice,
  driverPrice,
}) => {
  const dispatch = useAppDispatch();
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const [modalVisibility, setModalVisibility] = useState(true);
  const [notificationAPI, contextHolder] = notification.useNotification();
  const isLoading = useSelector(selectBidLoading);
  const currentBid = useSelector(selectCurrentOrder);

  const addBidHandler = (values: any) => {
    values.order_id = currentBid?.id;
    values.broker_price = brokerPrice || currentBid?.letter?.broker_price;
    values.driver_price = driverPrice || currentBid?.letter?.driver_price;

    console.log('Assigning bid form values =>', values);

    dispatch(assignBid(values)).then((action) => {
      if (action.payload) {
        notificationAPI.success({
          message: 'Bid was successfully assigned',
          duration: 2,
        });

        if (currentBid?.id) {
          dispatch(getOrder(currentBid?.id));
        }
        reset();
        setModalVisibility(false);
      } else {
        notificationAPI.error({
          message: "Internal error, bid wasn't assigned",
          duration: 4,
        });
      }
    });
  };

  return (
    <Modal
      open={modalVisibility && visible}
      footer={true}
      maskClosable={true}
      width={410}
      onCancel={() => {
        reset();
        onCancel();
      }}
      className={styles.assigningBidModal}
    >
      {contextHolder}
      <form
        className={styles.assigningBidModal__form}
        noValidate
        onSubmit={handleSubmit(addBidHandler)}
      >
        <Controller
          name="broker_company"
          control={control}
          rules={{ required: 'Please fill out this field.' }}
          render={({ field }) => (
            <CustomInput
              field={field}
              fieldName={field.name}
              labelName="Broker Company"
              error={errors[field.name]}
            />
          )}
        />

        <Controller
          name="rate_confirmation"
          control={control}
          rules={{ required: 'Please fill out this field.' }}
          render={({ field }) => (
            <CustomInput
              field={field}
              fieldName={field.name}
              labelName="Rate confirmation"
              error={errors[field.name]}
            />
          )}
        />

        <Button
          className={styles.assigningBidModal__btn}
          htmlType="submit"
          disabled={isLoading}
        >
          {isLoading ? <Spin /> : 'Assign shipment'}
        </Button>
      </form>
    </Modal>
  );
};
